import React, { useState, useEffect } from 'react';
import styles from './YourTownloopProductList.module.scss';
import { DeleteOutlined } from '@ant-design/icons';

type Product = {
  product_media_list: any[];
  product_sku_values: any[];
  product_id: string;
  product_title: string;
}
interface YourTownloopProductListProps {
  products: any[];
  // children: React.ReactNode;
  getId?: (id: string) => void; // 可选的回调函数
  needRenderDelete?: boolean
  deleteFavouriteProduct?: (id: string) => void
}

const YourTownloopProductList: React.FC<YourTownloopProductListProps> = ({ products, getId, needRenderDelete = false, deleteFavouriteProduct }) => {
  const baseDeleteFavouriteProduct = (e: any, productId: string) => {
    e.stopPropagation()
    deleteFavouriteProduct?.(productId)
  };
  const renderDeleteButton = (item: any) => {
    if (needRenderDelete) {
      return (
        <div className={styles['product-hover']} onClick={(e: any) => baseDeleteFavouriteProduct(e, item?.product?.product_id)}>
              <DeleteOutlined style={{ color: 'red', fontSize: '20px' }} />
            </div>
      )
    }
  }
  return (

    <div className={styles['products-block']}>

      {/* 订单区块 */}
      <div className={styles['orders-products-list']}>
        {products.map((item, idx) => (
          <div className={styles['product-item']} key={idx} onClick={() => getId && getId(item?.product?.product_id)}>
            {renderDeleteButton(item)}
            <img className={styles['product-img']} src={item?.product?.product_media_list[0]?.product_media_file_url || ''}  />
            <div
              className={`${styles['product-title']} overflowText`}
              title={item?.product?.product_title}
            >{item?.product?.product_title}
            </div>  
            <div className={styles['product-prices']}>
              <div className={styles['product-prices-subbox']}>
                <span className={styles['product-price']}>${item?.product?.product_sku_values[0]?.product_price || ''}</span>
                {/* <span className={styles['product-oldprice']}>{item?.product_sku_values[0]?.product_price || ''}</span> */}
              </div>
              {/* <span className={styles['product-sales']}>{item.sales}</span> */}
            </div>
          </div>
        ))}
      </div>
    </div>

  );
};

export default YourTownloopProductList; 